enum ResourceListEvents {
	Reveal = 'reveal',
}

type ResourceListEmitters = {
	[ResourceListEvents.Reveal]: (name: string) => void;
};

export { ResourceListEvents, ResourceListEmitters };
